//For some reason the require() stuff from pixi-spine is still trying to run on the next
//self-contained function, if that function follows pixi-spine immediately in libraries.js.
//The reason appears to be that pixi-spine lacks a trailing semicolon
;